import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";

export function locationsErrorMessageForBranches(
  branches: SavedLocation[],
  branchId: undefined | string,
) {
  // No branches, so can't be an error
  if (branches.length === 0) {
    return undefined;
  }

  if (branches.length > 0 && branchId === undefined) {
    return "Required";
  }

  return undefined;
}
